import React, { useEffect } from 'react';

import { Container } from '@mui/material';
import { useToggle } from 'react-use';

import classes from './NgzCustomerSelfSetup.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useStepper } from '../../../shared/hooks/useStepper';
import { QuestionnaireStep } from './containers/QuestionnaireStep/QuestionnaireStep';
import { PersonalInfoStep } from './containers/PersonalInfoStep/PersonalInfoStep';
import { IsKnownCoachStep } from './containers/IsKnownCoachStep/IsKnownCoachStep';
import { SelectSubscriptionStep } from './containers/SelectSubscriptionStep/SelectSubscriptionStep';
import { SelectCoachStep } from './containers/SelectCoachStep/SelectCoachStep';
import { questionnaireStore } from '../../stores/customerSelfSetupStores/questionnaireStore';
import { personalInfoStore } from '../../stores/customerSelfSetupStores/personalInfoStore';
import { coachStore } from '../../stores/customerSelfSetupStores/coachStore';
import {
  SetupCustomerStepper,
  StepOption,
} from '../../../shared/components/steppers/SetupCustomerStepper/SetupCustomerStepper';
import { ExplanationSetupSteps } from '../../components/customer-self-setup-components';

const NgzCustomerSelfSetup = () => {
  const [isShowExplanation, toggleShowExplanation] = useToggle(true);
  const stepperMethods = useStepper();
  const { activeStep } = stepperMethods;

  const { isKnownCoach } = coachStore;

  const stepsConfig: StepOption[] = [
    {
      title:
        'Answer the following questions to help us create a custom meal plan specific to you and your goals',
      description: 'Please select one answer per question',
      step: <QuestionnaireStep stepperMethods={stepperMethods} />,
    },
    {
      title: 'Great! Now, please fill out your information to create a profile',
      description: 'All fields are required',
      step: <PersonalInfoStep stepperMethods={stepperMethods} />,
    },
    {
      step: <IsKnownCoachStep stepperMethods={stepperMethods} />,
      title:
        'Do you know the name of the specific business and/or coach you would like to work with?',
      description: 'Select one of the available options',
    },
    {
      title: isKnownCoach
        ? 'Select coach you would like to work with'
        : 'Choose a collaboration format and coach from the provided list',
      description: isKnownCoach
        ? 'Use the filter for a quick search'
        : 'Please choose from one of the two options below',
      step: <SelectCoachStep stepperMethods={stepperMethods} />,
    },
    {
      title: 'Select a plan below that fits your needs',
      description: 'Select a subscription and proceed to the checkout with Stripe',
      step: <SelectSubscriptionStep stepperMethods={stepperMethods} />,
    },
  ];

  useEffect(() => {
    return () => {
      questionnaireStore.setDefaultValues();
      personalInfoStore.setDefaultValues();
      coachStore.setDefaultValues();
    };
  }, []);

  return (
    <Container maxWidth="sm" className={classes.container}>
      {isShowExplanation ? (
        <ExplanationSetupSteps onStart={toggleShowExplanation} />
      ) : (
        <SetupCustomerStepper activeStep={activeStep} stepsConfig={stepsConfig} />
      )}
    </Container>
  );
};

angularizeWithProviders(NgzCustomerSelfSetup, 'ngzCustomerSelfSetup', {});
